import { create } from 'zustand';
import { SearchAvailability } from '#server/models';
import { DEFAULT_YEAR } from '#server/constants';

export interface AvailabilityState {
  facetAvailabilities: Record<string, SearchAvailability | null>;
  currentFacet: string | null;
  activeAvailability: SearchAvailability;
  actions: {
    setCurrentFacet: (facet: string) => void;
    setActiveAvailability: (availability: SearchAvailability) => void;
  };
}

export const useAvailabilityStore = create<AvailabilityState>((set, get) => ({
  facetAvailabilities: {},
  currentFacet: null,
  activeAvailability: {
    year: DEFAULT_YEAR,
  },
  actions: {
    setCurrentFacet: (facet) => {
      const { facetAvailabilities } = get();
      const existing = facetAvailabilities[facet] ?? null;

      set((state) => ({
        currentFacet: facet,
        activeAvailability: existing ?? state.activeAvailability,
      }));
    },

    setActiveAvailability: (availability) =>
      set((state) => {
        if (!state.currentFacet) return state;

        return {
          activeAvailability: availability,
          facetSortOrders: {
            ...state.facetAvailabilities,
            [state.currentFacet]: availability,
          },
        };
      }),
  },
}));

export const useAvailabilityActions = () => useAvailabilityStore((s) => s.actions);
